import React from "react"
import { Navigate, Route, Routes } from "react-router-dom"

import EmailKnowledgePage from "./EmailKnowledgePage"

const EmailKnowledgeRoot: React.FC = () => (
  <Routes>
    <Route index element={<EmailKnowledgePage />} />
    <Route path="/:submissionId" element={<EmailKnowledgePage />} />
    <Route path="/*" element={<Navigate to="/email-knowledge" replace />} />
  </Routes>
)

export default EmailKnowledgeRoot
